import { getPercentageStringFromDecimal } from '@Utils/helpers/numericalHelpers';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectedFolderState } from '@Data/folders/Reducer';
import {
    AnalysisEntityState,
    IAnalysisEntity,
} from '@Data/qualityControl/Interfaces';
import {
    analysisEntitiesState,
    inspectedRateState,
    yieldRateState,
} from '@Data/qualityControl/Reducer';
import Styles from '../../QualityControlBlock.scss';
import { EntityDataRow } from '../EntityDataRow/EntityDataRow';

function getInspectedEntities(
    analysisEntities: IAnalysisEntity[]
): IAnalysisEntity[] {
    return analysisEntities.filter(
        (e) => e.qcState !== AnalysisEntityState.TODO
    );
}

export const Stats = () => {
    const analysisEntities = useSelector(analysisEntitiesState);
    const selectedFolder = useSelector(selectedFolderState);

    const targetInspectionRate = selectedFolder?.target_inspection_rate;
    const targetYieldRate = selectedFolder?.target_pass_yield;

    const inspectedRate = useSelector(inspectedRateState);
    const yieldRate = useSelector(yieldRateState);

    const inspectedRatePct = getPercentageStringFromDecimal(inspectedRate);
    const yieldRatePct = getPercentageStringFromDecimal(yieldRate, false);
    const targetInspectionRatePct =
        getPercentageStringFromDecimal(targetInspectionRate);
    const targetYieldRatePct = getPercentageStringFromDecimal(targetYieldRate);

    return (
        <div className={Styles.statsContainer}>
            <EntityDataRow
                keyName="Total Poles"
                value={analysisEntities.length}
            />
            <EntityDataRow
                keyName="Inspected"
                value={`${getInspectedEntities(analysisEntities).length} of ${
                    analysisEntities.length
                }`}
            />
            <EntityDataRow
                keyName="Inspection Rate"
                value={`Actual = ${inspectedRatePct}% Target = ${targetInspectionRatePct}%`}
                backgroundSuccess={inspectedRate >= targetInspectionRate}
            />
            <EntityDataRow
                keyName="Yield Rate"
                value={`Actual = ${yieldRatePct}% Target = ${targetYieldRatePct}%`}
                backgroundSuccess={
                    yieldRate >= targetYieldRate &&
                    inspectedRate >= targetInspectionRate
                }
            />
        </div>
    );
};
